import { connect } from 'react-redux';
import { openScheduledCommonRoomPosts } from '@app/actions/navigation/openScheduledPosts';
import { COMMON_ROOM } from '@core/constants/postFeedType';
import { hasFinishedFetchingPostsSelector } from '@core/selectors/classroom';
import {
  getNextScheduledPost,
  getScheduledPostsCount,
} from '@core/selectors/space';
import ScheduledPostsSummaryView from './ScheduledPostsSummary';

export const mapStateToProps = (state) => ({
  hasFinishedFetchingPosts: hasFinishedFetchingPostsSelector(state),
  scheduledPost: getNextScheduledPost(state, COMMON_ROOM),
  scheduledPostCount: getScheduledPostsCount(state, COMMON_ROOM),
});

export const mapDispatchToProps = (dispatch) => ({
  onViewScheduledPosts: () => dispatch(openScheduledCommonRoomPosts()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledPostsSummaryView);
